import { render, staticRenderFns } from "./admin-navbar.vue?vue&type=template&id=486f593a"
import script from "./admin-navbar.vue?vue&type=script&lang=js"
export * from "./admin-navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports